/*import { RiverErrors } from "@river/constants";*/
export const RiverErrorMessages = {
/*[RiverErrors.AUTH.INVALID_CREDENTIALS]:
  "Incorrect email address or password.",*/
};
